import React from 'react';
import profile_logo from '../../header_images/ati_logo.png';
import header_logo from '../../header_images/MyCPDLogoImg.png';
import header_logo_mobile from '../../header_images/MyCPDMain.png';
import user_Icon from '../../header_images/if_user_1902268.png';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { removeData } from '../../store/action';
import { Dropdown, MenuItem } from 'react-bootstrap';

let body = document.getElementsByTagName('body')

class App extends React.Component {
  componentDidMount() {
    this.onBackButtonEvent = this.onBackButtonEvent.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
    window.addEventListener('popstate', this.onBackButtonEvent);
    window.addEventListener("click",this.closeMenu);
  }

  onBackButtonEvent() {
    if (this.props?.updatequickNav) {
      this.props.updatequickNav(false, this.props?.user?.role);
    }
  }

  closeMenu() {
    let element = document.getElementById("bs-example-navbar-collapse-1");
    if(!!element){
      if (element?.classList?.contains("in")) {
        element.classList.toggle("in");
      }
    }
  }

  render() {
    if (!this.props.user.access_token) {
      return null;
    }

    let currentPath;
    const currentURL = window.location.href;

    const updatedPath = currentURL.split('#');

    if (updatedPath?.length) {
      let splitUpdatedPath = updatedPath[1].split('/');
      if (splitUpdatedPath.length) {
        currentPath = splitUpdatedPath[1];
      }
    }

    const role = this.props.user.role;
    return (
      <header
        css="headerdashboard"
        text="Home Page"
        style={{
          display: currentPath === 'login' ? 'none' : 'block',
        }}
        className="ng-scope ng-isolate-scope"
      >
        <div className="row shadow">
          <nav
            className="navbar navbar-default navbar-fixed-top"
            role="navigation"
          >
            <div className="container-fluid">
              <div className="navbar-header">
                <button
                  type="button"
                  className="navbar-toggle collapsed"
                  data-toggle="collapse"
                  data-target="#bs-example-navbar-collapse-1"
                >
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar"> </span>
                  <span className="icon-bar"> </span>
                  <span className="icon-bar"> </span>

                </button>
                <a href="#" className="navbar-brand">
                  <img src={header_logo} alt="" className='header-logo' />
                  <img src={header_logo_mobile} alt="" className='header-logo-mobile' width="40px" onClick={() => this.closeMenu()} />
                </a>
                <Dropdown id="dropdown-custom-navbar" className='user-icon'>
                  <Dropdown.Toggle noCaret>
                    <img src={user_Icon} width="37px" />
                  </Dropdown.Toggle>
                  <Dropdown.Menu style={{ left: '-113px' }}>
                    <MenuItem onClick={(e) => {
                      this.props.makeSignOutRequest(e);
                      this.props.signOut();
                    }}><i className="fa fa-sign-out"></i> Sign Out</MenuItem>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div
                id="bs-example-navbar-collapse-1"
                className="collapse navbar-collapse animated fadeIn"
              >
                <ul className="nav navbar-nav animated fadeIn text16">
                  <li
                    style={{
                      display: currentPath === 'home' ? 'none' : 'block',
                    }}
                  >
                    <a
                      href="#"
                      onClick={() => this.props?.updatequickNav(false, role)}
                      data-toggle="collapse"
                      data-target="#bs-example-navbar-collapse-1"
                    >
                      <i className="fa fa-home"> </i> Home{' '}
                    </a>
                  </li>
                  <li
                    className="active"
                    style={{
                      display: currentPath === 'home' ? 'none' : 'block',
                    }}
                  >
                    <a
                      onClick={() =>
                        this.props?.updatequickNav(
                          !this.props?.quickNavShown,
                          role
                        )
                      }
                      style={{ cursor: 'pointer' }}
                      data-toggle="collapse"
                      data-target="#bs-example-navbar-collapse-1"
                    >
                      <i
                        className={
                          this.props?.quickNavShown
                            ? 'fa fa-toggle-on'
                            : 'fa fa-toggle-off'
                        }
                      >
                        {' '}
                      </i>{' '}
                      Quick Navigation
                    </a>
                  </li>
                  {role === 'Member' && (
                    <li>
                      <a
                        onClick={() =>
                          this.props?.updatefeedBackModalShown(true)
                        }
                        style={{ cursor: 'pointer' }}
                        data-toggle="collapse"
                        data-target="#bs-example-navbar-collapse-1"
                      >
                        <i className="fa fa-paper-plane"> </i> Feedback!
                      </a>
                    </li>
                  )}
                </ul>
                <ul className="nav navbar-nav navbar-right animated fadeIn text16">
                  <li style={{ padding: '13px 15px 0', display: 'inline' }}>
                    {localStorage.getItem('displayName')}
                  </li>
                  <li>
                    <img src={profile_logo} className='ati-logo-responsive' />
                  </li>
                  <li aria-hidden="false" className="">
                    <a
                      onClick={() => this.props?.updateAboutUsModalShown(true)}
                      href="#"
                      data-toggle="collapse"
                      data-target="#bs-example-navbar-collapse-1"
                    >
                      <i className="fa fa-info-circle"></i> About Us
                    </a>
                  </li>
                  <li>
                    <a
                      onClick={(e) => {
                        this.props.makeSignOutRequest(e);
                        this.props.signOut();
                      }}
                      href="#"
                    >
                      <i className="fa fa-sign-out"></i> Sign Out
                    </a>
                  </li>
                </ul>
              </div>

              <h4
                className={
                  currentPath === 'home'
                    ? 'headerdashboard'
                    : 'headerpages nav-page-headers'
                }
              >
                {(() => {
                  switch (currentPath) {
                    case 'home':
                      return 'Home Page';
                    case 'cpdrecord':
                      return 'MyCPD DashBoard';
                    case 'mycpd':
                      return 'Record MyCPD';
                    case 'cpdgo':
                      return 'CPDgo';
                    case 'cpdclassroom':
                      return 'ATI CPD';
                    case 'CPDACCREDITED':
                      return 'Professional Exams and Further Education';
                    case 'cpdaccredited':
                      return 'Professional Exams and Further Education';
                    case 'library':
                      return 'CPD Calendar';
                    case 'cpdadmin':
                      return 'CPD Admin Dashboard and Library';
                    case 'memberadmin':
                      return 'Member Accounts';
                    case 'accredtadmin':
                      return 'Approval Queue';
                    case 'adminsetting':
                      return 'Admin Settings';

                    case 'host':
                      return 'Host';

                    case 'usermanagment':
                      return 'User Management';

                    case 'videoaccess':
                      return 'Video Access';

                    case 'affiliatereport':
                      return 'Affiliate Report';

                    case 'reportadmin':
                      return 'CPD Reports';

                    case 'compliantreport':
                      if (updatedPath[1] === '/compliantreport/CPD0003') {
                        return 'Non Compliant Report';
                      } else {
                        return 'Compliant Report';
                      }

                    case 'individualuserreport':
                      return 'Individual User Report';

                    case 'systemusagereport':
                      return 'System Usage Report';

                    case 'recordedzerohour':
                      if (
                        updatedPath[1] === '/recordedzerohour/CPD0007' ||
                        updatedPath[1] === '/recordedzerohour/CPD0008'
                      ) {
                        return 'Not Compliant User 1';
                      } else {
                        return 'Not Engaged';
                      }

                    case 'myCpdRecord':
                      return 'Record MyCPD';

                    case 'my_cpd_report':
                      return 'MyCPD DashBoard';

                    case 'monthviewcpd':
                      return 'Monthly View';

                    case 'register':
                      return 'Register Details';

                    case 'randomreport':
                      return 'Random User Report';

                    default:
                      return 'Home Page';
                  }
                })()}
              </h4>
            </div>
          </nav>
        </div>
      </header>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(App));
